import { useTranslation } from "react-i18next";
import { formatNumber } from "@/utilities/formatNumber";

/**
 * Returns the number formatted according to the user's locale.
 *
 * @param number - The number to format.
 * @param precision - The number of decimal places to display (default: 0)
 * @returns - The formatted number.
 */
export function useFormattedNumber(number?: number | string, precision = 0) {
  const { i18n } = useTranslation();
  if (typeof number === "string" || Number.isNaN(number)) {
    return "---";
  }

  if (number === undefined) {
    return number;
  }

  return formatNumber(number, i18n.language, precision);
}
